export default "__VITE_ASSET__E4GNRmUC__"